// extracted by mini-css-extract-plugin
module.exports = {"SM":"360px","MD":"640px","LG":"1200px","Root":"GlobalFilter_Root__Y_bHF","Input":"GlobalFilter_Input__1oNAL"};